// extracted by mini-css-extract-plugin
export var chip = "_63-9";
export var chipLabel = "_63-a";
export var close = "_63-7";
export var closeIcon = "_63-8";
export var error = "_63-6";
export var infoTooltip = "_63-2";
export var innerContainer = "_63-1";
export var input = "_63-b";
export var medium = "_63-5";
export var outerContainer = "_63-0";
export var small = "_63-4";
export var xSmall = "_63-3";